import { OptionsObject } from 'notistack';

export const AutoHideDuration = 5000;
export const InformationSnackbar: OptionsObject = {
  variant: 'info',
  autoHideDuration: AutoHideDuration,
  preventDuplicate: true,
};
